import { Box } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { formDataAtom, otherErrorsAtom, updateFieldAtom } from "../store/onboardingModalStore";
import { improvementOptions } from "../constants/chipData";
import { OnboardingSelectionChip } from "./shared/OnboardingSelectionChip";
import { OnboardingStepLayout } from "./shared/OnboardingStepLayout";
import { OnboardingOtherInput } from "./shared/OnboardingOtherInput";

export const OnboardingImprovements = (): JSX.Element | null => {
  const [formData] = useAtom(formDataAtom);
  const updateField = useSetAtom(updateFieldAtom);
  const [otherErrors, setOtherErrors] = useAtom(otherErrorsAtom);

  const orgType = formData.orgType;
  if (!orgType) return null;

  const options = improvementOptions[orgType];
  const isOtherSelected = formData.improvements.includes("other");

  const handleToggle = (value: string): void => {
    const current = formData.improvements;
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    updateField({ improvements: updated });
    if (value === "other" && current.includes("other")) {
      const { improvements: _, ...rest } = formData.otherTexts;
      updateField({ otherTexts: rest });
    }
  };

  return (
    <OnboardingStepLayout
      title="What are you hoping to improve?"
      subtitle="Help us understand what's slowing your team down today. We'll use this to set up DeskDay around your priorities."
    >
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {options.map((option) => (
          <OnboardingSelectionChip
            key={option.value}
            label={option.label}
            isSelected={formData.improvements.includes(option.value)}
            onClick={() => handleToggle(option.value)}
            showCheck
          />
        ))}
      </Box>
      {isOtherSelected && (
        <Box sx={{ marginTop: "8px" }}>
          <OnboardingOtherInput
            value={formData.otherTexts.improvements ?? ""}
            onChange={(val) =>
              updateField({
                otherTexts: { ...formData.otherTexts, improvements: val },
              })
            }
            error={!!otherErrors.improvements}
            onErrorClear={() => {
              const { improvements: _, ...rest } = otherErrors;
              setOtherErrors(rest);
            }}
          />
        </Box>
      )}
    </OnboardingStepLayout>
  );
};
